import buildConfig from '../buildConfig';
/* 不同环境，不同俱乐部配置文件，根据  process.env.VUE_APP_NODE ||  process.env.VUE_APP_AUDIENCE  判断 */
let localUrl;
// 本地调试地址，方便开发使用
// 打包时可不注释此处，不受影响

// 设置 oss bucket
const ossBucketVideo = 'acme-video';
const ossBucketFile = 'acme-storage';
// 动态字段接口
const clubhubUrl = {
  testing: 'https://newapi.test.acme-ai.com/clubhub', // 测试地址
  production: 'https://newapi.acme-ai.com/clubhub', // 正式地址
};
// 视频模块，同步 vi 视频时，登录及列表接口使用 vi 接口
const syncViVideo = {
  testing: 'https://api.test.acme-ai.com/vi', // 测试地址
  production: 'https://api.acme-ai.com/vi', // 正式地址
};

// 配置CMS地址
const CMSAPI = {
  testing: 'https://newapi.test.acme-ai.com/cms', // 测试地址
  production: 'https://newapi.acme-ai.com/cms', // 正式地址
};

// 设置专业版地址
let eliteUrl = {
  testing: 'https://newapi.test.acme-ai.com', // 测试地址
  production: 'https://newapi.acme-ai.com', // 正式地址
};

// 设置画图工具的地址 fabric
let fabricURL = {
  testing: 'https://fabric.test.acme-ai.com', // 测试地址
  production: 'https://fabric.acme-ai.com', // 正式地址
};

// 设置模板地址
let templateUrl = {
  testing: 'https://newapi.test.acme-ai.com/template',
  production: 'https://newapi.acme-ai.com/template',
};

// 设置资源库地址
let resourceUrl = {
  testing: 'https://newapi.test.acme-ai.com/library',
  production: 'https://newapi.acme-ai.com/library',
};

// 赛事地址
let tournamentUrl = {
  testing: 'https://newapi.test.acme-ai.com/tournament',
  production: 'https://newapi.acme-ai.com/tournament',
};

// 伤病接口地址
const injuryUrl = {
  testing: 'https://newapi.test.acme-ai.com/injury', // 测试地址
  production: 'https://newapi.acme-ai.com/injury', // 正式地址
};
// 配置 staige 地址
const staigeUrl = {
  testing: 'https://newapi.acme-ai.com/vision-insight', // 测试地址
  production: 'https://newapi.acme-ai.com/vision-insight', // 正式地址
};
// 平台key
const PLATFORM = 'MASTER';

// 设置智能比赛报告的详情地址
const reportURL = {
  testing: 'https://web.report.test.acme-ai.com', // 测试地址
  production: 'https://web.report.acme-ai.com', // 正式地址
};

// 比赛报告接口地址
const tournamentReportUrl = {
  testing: 'https://newapi.test.acme-ai.com/match-report', // 测试地址
  production: 'https://newapi.acme-ai.com/match-report', // 正式地址
};

// 设置 oss 文件夹中视频路径
const ossVideos = {
  testing: '/',
  production: '/',
};

// 设置 oss 文件夹中视频画图文件路径
const ossCovers = {
  testing: '/',
  production: '/',
};
// 公共页面地址
const externalURL = {
  testing: 'https://web.external.test.acme-ai.com',
  production: 'https://web.external.acme-ai.com',
};
const leaderURL = {
  testing: 'https://newapi.test.acme-ai.com/leader-report',
  //   testing: 'http://10.0.0.146:8080',
  production: 'https://newapi.acme-ai.com/leader-report',
};
// oss公共目录url
const OSS_PUB = 'https://club-pub.oss-cn-beijing.aliyuncs.com';

let baseURL = {
  // // 在本地开发时，localUrl 存在时走 localUrl，localUrl 不存在时走 testing 的 VUE_APP_BASEURL，此时可以启动多个项目
  development: localUrl ? localUrl : process.env.VUE_APP_BASEURL,
  // testing 环境
  testing: process.env.VUE_APP_BASEURL,
  // production 环境
  production: process.env.VUE_APP_BASEURL,
};
let baseURL_teamup = {
  // // 在本地开发时，localUrl 存在时走 localUrl，localUrl 不存在时走 testing 的 VUE_APP_BASEURL，此时可以启动多个项目
  development: localUrl ? localUrl : process.env.VUE_APP_BASEURL_TEAMUP,
  // testing 环境
  testing: process.env.VUE_APP_BASEURL_TEAMUP,
  // production 环境
  production: process.env.VUE_APP_BASEURL_TEAMUP,
};

// 产品名称 小写
const APP_NAME_LOWER = process.env.VUE_APP_AUDIENCE.toLowerCase();

// 暴露JS层面的内容
export default {
  APP_NAME: process.env.VUE_APP_AUDIENCE, // 对应产品(大写)
  APP_NAME_LOWER, // 对应产品小写
  clubhubUrl: clubhubUrl[process.env.VUE_APP_NODE],
  CLUB_NAME: process.env.VUE_APP_AUDIENCE, // 对应俱乐部
  REQUEST_URL: baseURL[process.env.NODE_ENV], // 不同环境接口地址
  REQUEST_URL_TEAMUP: baseURL_teamup[process.env.NODE_ENV],
  DOWN_KEY: process.env.VUE_APP_DOWN_KEY, // 下载app时传给后端的
  DOWN_NAME: process.env.VUE_APP_DOWN_NAME, // 下载app时传给后端的name
  OSS_PUB: OSS_PUB, // oss公共地址
  ossBucketVideo: ossBucketVideo, // 上传video的oss地址
  ossBucketFile: ossBucketFile, // 除video以外的所有file上传oss地址
  OSS_URL: '/', // oss 文件路径
  OSS_VIDEOSURL: ossVideos[process.env.VUE_APP_NODE], // oss 视频文件路径
  OSS_COVERSURL: ossCovers[process.env.VUE_APP_NODE], // oss 视频画图文件路径
  fabricURL: fabricURL[process.env.VUE_APP_NODE],
  templateUrl: templateUrl[process.env.VUE_APP_NODE],
  resourceUrl: resourceUrl[process.env.VUE_APP_NODE],
  tournamentUrl: tournamentUrl[process.env.VUE_APP_NODE],
  injuryUrl: injuryUrl[process.env.VUE_APP_NODE], // 伤病接口
  staigeUrl: staigeUrl[process.env.VUE_APP_NODE], // staige接口
  currentYearFirstDay: new Date().getFullYear() + '/01/01',
  countriesUrl: OSS_PUB + '/common/images/countries/', // 国籍图片oss地址
  reportURL: reportURL[process.env.VUE_APP_NODE], // 智能比赛报告的详情地址
  tournamentReportUrl: tournamentReportUrl[process.env.VUE_APP_NODE], // 比赛报告接口地址
  viApiUrl: syncViVideo[process.env.VUE_APP_NODE],
  CITY_IMG_URL: OSS_PUB + '/pc/images/citys/', // 城市icon地址
  SHORTCUT_IMG_URL: OSS_PUB + '/pc/images/shortcut/', // 快捷方式地址
  APPID: buildConfig.APPID[process.env.VUE_APP_NODE], // appId
  eliteUrl: eliteUrl[process.env.VUE_APP_NODE], // UIMS地址
  CMSAPI: CMSAPI[process.env.VUE_APP_NODE], // CMS地址
  externalURL: externalURL[process.env.VUE_APP_NODE], // 公共外部链接
  PLATFORM: PLATFORM, // 平台key
  nodePort: process.env.VUE_APP_NODE_PORT,
  leaderURL: leaderURL[process.env.VUE_APP_NODE],
};
